import { Query } from 'react-apollo'
import myClosedLoans, { MyClosedLoans } from '../../graphql/queries/myClosedLoans'
import withQuery from './withQuery'
import { GetProps } from '../../types'

class MyClosedLoansQuery extends Query<MyClosedLoans, {}> {}

const MyClosedLoansQueryCompleted = withQuery(myClosedLoans)(MyClosedLoansQuery)

export type MyClosedLoansQueryProps = GetProps<typeof MyClosedLoansQueryCompleted>
export type MyClosedLoansQueryResult = MyClosedLoans

export default MyClosedLoansQueryCompleted  



// WEBPACK FOOTER //
// ./src/components/queries/MyClosedLoansQuery.tsx